/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inquire_Ask_A_QuestionInputs */

const en_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inquire / Ask a Question`)
};

const es_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultar / Hacer una pregunta`)
};

const fr_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se renseigner / Poser une question`)
};

const de_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfragen / Frage stellen`)
};

const ja_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問い合わせ / 質問する`)
};

const zh_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`咨询 / 提问`)
};

const ar_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استفسر / اطرح سؤالاً`)
};

const id_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanya / Ajukan Pertanyaan`)
};

const it_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiedi / Fai una Domanda`)
};

const ru_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросить информацию / Задать вопрос`)
};

const pt_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultar / Fazer uma Pergunta`)
};

const ko_inquire_ask_a_question = /** @type {(inputs: Inquire_Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의 / 질문하기`)
};

/**
* | output |
* | --- |
* | "Inquire / Ask a Question" |
*
* @param {Inquire_Ask_A_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inquire_ask_a_question = /** @type {((inputs?: Inquire_Ask_A_QuestionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inquire_Ask_A_QuestionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inquire_ask_a_question(inputs)
	if (locale === "es") return es_inquire_ask_a_question(inputs)
	if (locale === "fr") return fr_inquire_ask_a_question(inputs)
	if (locale === "de") return de_inquire_ask_a_question(inputs)
	if (locale === "ja") return ja_inquire_ask_a_question(inputs)
	if (locale === "zh") return zh_inquire_ask_a_question(inputs)
	if (locale === "ar") return ar_inquire_ask_a_question(inputs)
	if (locale === "id") return id_inquire_ask_a_question(inputs)
	if (locale === "it") return it_inquire_ask_a_question(inputs)
	if (locale === "ru") return ru_inquire_ask_a_question(inputs)
	if (locale === "pt") return pt_inquire_ask_a_question(inputs)
	return ko_inquire_ask_a_question(inputs)
});